document.addEventListener("DOMContentLoaded", function () {
  amMobileNav();
});

function amMobileNav() {
  const hamburgerMenuBtn = document.getElementById("am-mb-open-menu");
  const mobileMenu = document.getElementById("am-mb-menu-content");
  const closeBtn = document.getElementById("am-mb-close-btn");
  const closeMenuBtn = document.getElementById("am-mb-close-menu");

  if (!hamburgerMenuBtn || !mobileMenu || !closeBtn || !closeMenuBtn) {
    return;
  }

  function openMenu() {
    mobileMenu.classList.remove("am-nb__mb-nav-menu--hidden");
    mobileMenu.setAttribute("aria-hidden", "false");
    hamburgerMenuBtn.setAttribute("aria-expanded", "true");
    closeMenuBtn.classList.remove("hidden");
    hamburgerMenuBtn.classList.add("hidden");
    // Focus the first menu item for accessibility
    const firstMenuItem = mobileMenu.querySelector('a[role="menuitem"]');
    if (firstMenuItem) firstMenuItem.focus();
    // Trap focus inside mobile menu
    document.addEventListener("keydown", trapFocus);
    document.addEventListener("keydown", handleEsc);
  }

  function closeMenu() {
    mobileMenu.classList.add("am-nb__mb-nav-menu--hidden");
    mobileMenu.setAttribute("aria-hidden", "true");
    hamburgerMenuBtn.setAttribute("aria-expanded", "false");
    closeMenuBtn.classList.add("hidden");
    hamburgerMenuBtn.classList.remove("hidden");
    hamburgerMenuBtn.focus();
    document.removeEventListener("keydown", trapFocus);
    document.removeEventListener("keydown", handleEsc);
  }

  function handleEsc(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeMenu();
    }
  }

  function trapFocus(e) {
    // Optional: trap focus within the mobile menu for accessibility
    if (e.key !== "Tab") return;
    const focusableEls = mobileMenu.querySelectorAll(
      'a, button:not(.hidden), [tabindex]:not([tabindex="-1"])'
    );
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        lastEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastEl) {
        firstEl.focus();
        e.preventDefault();
      }
    }
  }

  hamburgerMenuBtn.addEventListener("click", function (event) {
    event.stopPropagation();
    openMenu();
  });

  closeBtn.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenu();
  });

  closeMenuBtn.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenu();
  });
}
